import Image from "next/image";
import React from "react";
import AccuracyIcon from "../../public/images/invest/accuracy-icon.svg";
import EfficiencyIcon from "../../public/images/invest/efficiency-icon.svg";
import SimplicityIcon from "../../public/images/invest/simplicity-icon.svg";

const InvestFeatures = () => {
  const features = [
    {
      icon: SimplicityIcon,
      label: "Simplicity",
      description:
        "Friction impedes our ability to complete tasks rapidly. EasyDuct is bringing about a revolution in manufacturing by placing simplicity at the heart of all our endeavors. We believe that software ought to be as simple as a coloring book and as uncomplicated as connecting dots.",
    },
    {
      icon: EfficiencyIcon,
      label: "Efficiency",
      description:
        "The impetus behind businesses is efficiency. Unless we can accomplish tasks at a quicker pace and lower cost, they are not deemed worthwhile. EasyDuct surpasses traditional paper methods in terms of speed and is more cost-effective than manual input. Additionally, using EasyDuct is an enjoyable experience!",
    },
    {
      icon: AccuracyIcon,
      label: "Accuracy",
      description:
        "Mistakes can significantly erode profits. The primary reason why contractors favor the EasyDuct App is because it assists them in identifying input errors. Errors are a major source of frustration for project managers, and when you have equipment and a team on-site, it is imperative to ensure that all aspects of the project are error-free.",
    },
  ];
  return (
    <div className="bg-full-bleed-green">
      <div className="py-40">
        <div className="flex gap-10">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col w-[33%]">
              <div className="border-b-[6px] pb-16 border-[#00E09E]">
                <div className="flex items-center gap-10">
                  <div className="bg-[#00E09E] flex justify-center rounded-[2rem] w-[110px] h-[100px]">
                    <Image
                      src={feature.icon}
                      width={110}
                      height={100}
                      className="h-[auto]"
                      alt=""
                    />
                  </div>
                  <div className="font-bold">
                    Obsessed with
                    <br />
                    <span className="text-3xl font-extrabold">
                      {feature.label}
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-5 font-semibold leading-loose">
                {feature.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvestFeatures;
